/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.1
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Jade Document status
 */
export type JadeDocumentStatusEnum = 'NOT_UPLOADED' | 'UPLOADED' | 'LEGAL_HOLD' | 'IN_PROCESSING' | 'AVAILABLE' | 'PROCESSING_FINISHED' | 'PROCESSING_FAILED' | 'DELETED_LOGICALLY' | 'DELETED_GDPR';

export const JadeDocumentStatusEnum = {
	NOTUPLOADED: 'NOT_UPLOADED' as JadeDocumentStatusEnum,
	UPLOADED: 'UPLOADED' as JadeDocumentStatusEnum,
	LEGALHOLD: 'LEGAL_HOLD' as JadeDocumentStatusEnum,
	INPROCESSING: 'IN_PROCESSING' as JadeDocumentStatusEnum,
	AVAILABLE: 'AVAILABLE' as JadeDocumentStatusEnum,
	PROCESSINGFINISHED: 'PROCESSING_FINISHED' as JadeDocumentStatusEnum,
	PROCESSINGFAILED: 'PROCESSING_FAILED' as JadeDocumentStatusEnum,
	DELETEDLOGICALLY: 'DELETED_LOGICALLY' as JadeDocumentStatusEnum,
	DELETEDGDPR: 'DELETED_GDPR' as JadeDocumentStatusEnum
};
